import { Box, Breadcrumbs, Icon, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import MobileViewBreadCrumbs from 'components/Shared/Breadcrumb/MobileView'
import useDeviceDetect from 'lib/hooks/UseDeviceDetect'
import { BreadcrumbStyles } from 'components/Shared/Breadcrumb/Styles'

const Breadcrumb = (props: CommonBreadcrumbs) => {
  const { items } = props
  const { isMobile } = useDeviceDetect()

  const renderCrumbs = () => {
    return items.map((item) => {
      return (
        <Link
          key={`${item.name}-breadcrumb`}
          data-testid={`${item.name}-breadcrumb`}
          to={item.link}
          style={BreadcrumbStyles.crumbStyles}
        >
          {item.icon && (
            <Icon
              data-testid={item.icon}
              className={item.iconStyle}
              sx={BreadcrumbStyles.iconStyles}
            >
              {item.icon}
            </Icon>
          )}
          <Typography color="text.primary">{item.name}</Typography>
        </Link>
      )
    })
  }

  if (isMobile && items.length > 2) {
    return <MobileViewBreadCrumbs items={items} />
  }

  return (
    <Box role="presentation">
      <Breadcrumbs aria-label="breadcrumb">{renderCrumbs()}</Breadcrumbs>
    </Box>
  )
}

export default Breadcrumb
